<!-- <template>
  <div>
    <div class="collapsible" ref>
        <input type="checkbox" :id="id" class="toggle">
        <div class="collapsible-content" ref="contentRef">
           <slot name="content"></slot>
        </div>
        <label :for="id" class="toggle-label" @click="changeSwitch">
          <span v-if="isShow">{{ $t('collpase_hide') }}</span>
          <span v-else>{{ $t('collpase_show') }}</span>
        </label>
    </div>
  </div>
</template>
<script>
import { ref } from '@nuxtjs/composition-api';
export default {
  name: 'CollapsibleText',
  props: {
    id: {
      type: String,
      default: 'collapsible-1'
    }
  },
  setup() {
    const isShow = ref(false);
    const contentRef = ref(null);
    const changeSwitch = () => {
      isShow.value = !isShow.value;
      if (isShow.value) {
        contentRef.value.style.height = 'auto';
      } else {
        contentRef.value.style.height = '4rem';
      }
    };
    return {
      isShow,
      changeSwitch,
      contentRef
    };
  }
};
</script>
<style lang="scss" scoped>
.collapsible {
  position: relative;
  // border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0 0 15px 0;
  margin-bottom: 20px;
}

.collapsible-content {
  // max-height: 4em; /* 3 lines of text */
  height: 4rem;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  text-overflow: ellipsis;
  display: -webkit-box;
}

.toggle {
  display: none;
}

.toggle-label {
  position: absolute;
  bottom: 0px;
  right: 10px;
  background-color: #fff;
  padding: 0 5px;
  cursor: pointer;
  font-size: 14px;
  color: #007bff;
}

.collapsible-content p {
  margin: 0;
  padding: 0;
}

.collapsible-content p:not(:first-child) {
  display: none;
}

.toggle:checked + .collapsible-content p:not(:first-child) {
  display: block;
}

.toggle:not(:checked) + .collapsible-content::after {
  content: '...';
  position: absolute;
  bottom: 5px;
  right: 40px;
}
</style> -->
<template>
  <div class="collapsible-text">
    <p :class="{ truncated: !expanded }" style="margin-bottom:0">
      {{ text }}
    </p>
    <button v-if="showBtn" @click="toggleExpand" class="read-more-btn">
      {{ expanded ? $t('collpase_hide') : $t('collpase_show') }}
    </button>
  </div>
</template>

<script >
import { ref, computed } from '@nuxtjs/composition-api';
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    maxLength: {
      type: Number,
      default: 300
    }
  },
  setup(props) {
    const expanded = ref(false);

    const toggleExpand = () => {
      expanded.value = !expanded.value;
    };

    const truncatedText = computed(() => {
      if (props.text.length <= props.maxLength) {
        return props.text;
      }
      return props.text.slice(0, props.maxLength) + '...';
    });
    const showBtn = computed(() => {
      return props.text.length !== 0 && props.text.length > props.maxLength;
    });
    console.log('props.text', props.text.length, props.maxLength);
    return {
      expanded,
      toggleExpand,
      truncatedText,
      showBtn
    };
  }
};

</script>

<style lang="scss" scoped>
.collapsible-text {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  line-height: 1.5;
  color: #333;
}

.truncated {
  overflow: hidden;
  display: -webkit-box;
  @include for-mobile{
    -webkit-line-clamp: 5;
  }
  @include for-desktop{
    -webkit-line-clamp: 8;
  }
  -webkit-box-orient: vertical;
}
@include for-mobile{
  .read-more-btn {
    background: none;
    border: none;
    color: #007bff;
    cursor: pointer;
    font-size: 0.9em;
    padding: 0;
    margin-top: 0px;
  }
}
@include for-desktop{
  .read-more-btn {
    background: none;
    border: none;
    color: #007bff;
    cursor: pointer;
    font-size: 1em;
    padding: 0;
    margin-top: 0px;
    display: none;
  }
}
.read-more-btn:hover {
  text-decoration: underline;
}
</style>
